import React from 'react';
import { Scale, BookOpen, Award, Users, Landmark, Briefcase } from 'lucide-react';
import CTAButton from './CTAButton';

const AboutUs: React.FC = () => {
  return (
    <section className="py-16 bg-primary text-white relative" id="about">
      <div className="absolute inset-0 bg-[url('/drafundo.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        {/* Cabeçalho e título */}
        <div className="flex justify-center mb-8">
          <div className="bg-accent/20 p-4 rounded-full">
            <img src="/logo2.png" alt="Logo" style={{ width: '100px', height: 'auto' }} className="object-contain" />
          </div>
        </div>
        
        <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-6 text-center">
          SOBRE NÓS
        </h2>
        
        <div className="text-center max-w-3xl mx-auto mb-10">
          <p className="text-lg mb-6 text-white/90">
            Dra. Lidiane Almeida é especialista em Direito Bancário e Direito do Trabalho, com atuação
            à nível nacional, de forma totalmente digital para acelerar a resolução das causas e prezar
            pelo conforto dos seus clientes.
          </p>
          
          <p className="text-lg text-white/90">
            Contamos com profissionais altamente capacitados na matéria, preocupados com a
            constante atualização dos seus conhecimentos e implantação de inovações tecnológicas
            para atender seus clientes com máxima eficiência.
          </p>
        </div>
        
        {/* Imagem para dispositivos móveis - visível apenas em telas pequenas */}
        <div className="block md:hidden mb-8 w-full flex items-center justify-center">
          <div className="bg-white/10 rounded-lg overflow-hidden w-full max-w-xs flex items-center justify-center p-2">
            <img 
              src="/dralidiane.png" 
              alt="Dra. Lidiane Almeida" 
              className="w-full max-w-[260px] h-auto object-contain block"
              style={{ display: 'block' }}
            />
          </div>
        </div>
        
        {/* Layout principal usando Grid para garantir alinhamento lado a lado */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch">
          {/* Lado esquerdo - Grid de cards (ocupa 4/5 do espaço) */}
          <div className="lg:col-span-4 grid grid-cols-1 sm:grid-cols-2 gap-6 auto-rows-min">
            <div className="bg-white/10 p-5 rounded-lg hover:bg-white/15 transition-all duration-300 flex items-start">
              <BookOpen className="text-accent mr-4 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg mb-2">Especialização</h3>
                <p className="text-white/80">Foco exclusivo em direito bancário e desbloqueio de contas.</p>
              </div>
            </div>
            
            <div className="bg-white/10 p-5 rounded-lg hover:bg-white/15 transition-all duration-300 flex items-start">
              <Award className="text-accent mr-4 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg mb-2">Excelência</h3>
                <p className="text-white/80">Profissionais com vasta experiência e altos índices de sucesso.</p>
              </div>
            </div>
            
            <div className="bg-white/10 p-5 rounded-lg hover:bg-white/15 transition-all duration-300 flex items-start">
              <Users className="text-accent mr-4 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg mb-2">Atendimento</h3>
                <p className="text-white/80">Suporte personalizado e totalmente digital para sua comodidade.</p>
              </div>
            </div>
            
            <div className="bg-white/10 p-5 rounded-lg hover:bg-white/15 transition-all duration-300 flex items-start">
              <Scale className="text-accent mr-4 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg mb-2">Abrangência</h3>
                <p className="text-white/80">Atuação em todo território nacional para resolver seu caso.</p>
              </div>
            </div>
            
            <div className="bg-white/10 p-5 rounded-lg hover:bg-white/15 transition-all duration-300 flex items-start">
              <Landmark className="text-accent mr-4 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg mb-2">Direito Bancário</h3>
                <p className="text-white/80">Especialização em desbloqueio de contas, recuperação de valores e revisão de contratos bancários.</p>
              </div>
            </div>
            
            <div className="bg-white/10 p-5 rounded-lg hover:bg-white/15 transition-all duration-300 flex items-start">
              <Briefcase className="text-accent mr-4 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg mb-2">Direito do Trabalho</h3>
                <p className="text-white/80">Atuação estratégica em processos trabalhistas, garantindo seus direitos com excelência.</p>
              </div>
            </div>
          </div>
          
          {/* Lado direito - Container para imagem (ocupa 1/5 do espaço) - visível apenas em telas médias e grandes */}
          <div className="hidden md:flex lg:col-span-1 items-center justify-center">
            <div className="bg-white/10 rounded-lg overflow-hidden w-full h-full flex items-center justify-center p-2">
              <img 
                src="/dralidiane.png" 
                alt="Dra. Lidiane Almeida" 
                className="w-full h-full object-contain"
                style={{ display: 'block' }}
              />
            </div>
          </div>
        </div>
        
        {/* Seção de CTA */}
        <div className="text-center mt-12" id="contact-form">
          <h3 className="font-heading font-semibold text-xl mb-6">Pronto para recuperar seus valores?</h3>
          <CTAButton />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;